import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as NotificationIconBleu } from '../assets/pageheader/notification_icon.svg';
import { ReactComponent as NotificationIconJaune } from '../assets/pageheader/notification_jaune.svg';
import { ReactComponent as NotificationIconRouge } from '../assets/pageheader/notification_rouge.svg';
import { ReactComponent as PPBleu } from '../assets/pageheader/PP_bleue.svg';
import { ReactComponent as PPJaune } from '../assets/pageheader/PP_jaune.svg';
import { ReactComponent as PPRouge } from '../assets/pageheader/PP_rouge.svg';
import { SHOW_NOTIFICATIONS } from '../constants/featureFlags';
import './PageHeader.css';

const PageHeader = ({ title, titleColor = 'var(--color-primary)', page = 'default' }) => {
  const navigate = useNavigate();

  // Select icons based on current page
  let NotificationIcon = NotificationIconBleu;
  let PPIcon = PPBleu;

  if (page === 'cycle') {
    NotificationIcon = NotificationIconJaune;
    PPIcon = PPJaune;
  } else if (page === 'mental') {
    NotificationIcon = NotificationIconRouge;
    PPIcon = PPRouge;
  }

  return (
    <div className="page-header">
      <h1 className="page-header__title" style={{ color: titleColor }}>
        {title}
      </h1>
      <div className="page-header__actions">
        {SHOW_NOTIFICATIONS && (
          <button className="page-header__btn" aria-label="Notifications">
            <NotificationIcon className="page-header__icon" />
          </button>
        )}
        <button className="page-header__avatar-btn" onClick={() => navigate('/profil')} aria-label="Mon profil">
          <PPIcon className="page-header__avatar" />
        </button>
      </div>
    </div>
  );
};

export default PageHeader;
